import { useState, useRef, useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { LogOut, User } from "lucide-react";

export const UserMenu = () => {
  const { user, logout } = useAuth();
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  if (!user) return null;
  const initials = (user.name || user.email || "?").split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();

  return (
    <div className="relative" ref={wrapperRef}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="user-menu-trigger"
        className="flex items-center gap-2 h-9 pl-1 pr-3 rounded-sm border border-[#262626] hover:border-[#404040] bg-[#141414] hover:bg-[#1F1F1F] transition-colors"
      >
        {user.picture ? (
          <img src={user.picture} alt="" className="w-7 h-7 rounded-sm object-cover"/>
        ) : (
          <div className="w-7 h-7 rounded-sm bg-[#0A84FF]/20 border border-[#0A84FF]/40 flex items-center justify-center">
            <span className="text-[10px] font-mono-data text-[#0A84FF] tracking-wider">{initials}</span>
          </div>
        )}
        <span className="hidden md:inline text-xs font-mono-data text-white tracking-wider uppercase truncate max-w-[120px]" data-testid="user-menu-name">
          {user.name}
        </span>
      </button>
      {open && (
        <div
          className="absolute right-0 top-11 w-60 bg-[#141414] border border-[#262626] rounded-sm shadow-xl overflow-hidden z-50"
          data-testid="user-menu-dropdown"
        >
          <div className="px-3 py-2.5 border-b border-[#262626] flex items-center gap-2">
            <User className="w-3.5 h-3.5 text-[#737373]" strokeWidth={1.6}/>
            <div className="min-w-0">
              <div className="text-sm text-white truncate">{user.name}</div>
              <div className="text-[11px] text-[#737373] font-mono-data truncate">{user.email}</div>
            </div>
          </div>
          <button
            type="button"
            onClick={logout}
            data-testid="logout-btn"
            className="w-full flex items-center gap-2 px-3 py-2.5 text-left text-sm text-[#E5E5E5] hover:bg-[#1F1F1F] transition-colors"
          >
            <LogOut className="w-3.5 h-3.5 text-[#FF453A]" strokeWidth={1.6}/>
            <span>Sign out</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
